import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Dynamictemplate extends Component {
 
  render() {
    const course =[
      {
        title : "Introduction to Dynamics 365",
        content: [
        "Overview of Dynamics 365",
        "Key features and capabilities",
        "Deployment options",
        "Navigation and user interface",
        "Getting started with Dynamics 365"
        ]
        },
        {
        title : "Sales Management in Dynamics 365",
        content: [
        "Managing leads and opportunities",
        "Creating and managing accounts and contacts",
        "Managing sales quotes and orders",
        "Tracking sales activities",
        "Sales forecasting and reporting"
        ]
        },
        {
        title : "Customer Service in Dynamics 365",
        content: [
        "Managing cases and customer inquiries",
        "Creating and managing service requests",
        "Creating and managing service agreements",
        "Service scheduling and dispatching",
        "Service reporting and analytics"
        ]
        },
        {
        title : "Marketing in Dynamics 365",
        content: [
        "Creating and managing marketing campaigns",
        "Marketing list management",
        "Lead scoring and qualification",
        "Email marketing and templates",
        "Marketing reporting and analytics"
        ]
        },
        {
        title : "Project Service Automation in Dynamics 365",
        content: [
        "Managing projects and project tasks",
        "Resource management and scheduling",
        "Project billing and cost management",
        "Project reporting and analytics",
        "Integrating with other Dynamics 365 modules"
        ]
        },
        {
        title : "Field Service in Dynamics 365",
        content: [
        "Creating and managing work orders",
        "Field service scheduling and dispatching",
        "Resource management and scheduling",
        "Field service reporting and analytics",
        "Integrating with other Dynamics 365 modules"
        ]
        },
        {
        title : "Finance and Operations in Dynamics 365",
        content: [
        "Managing financials and accounting",
        "Purchasing and procurement management",
        "Inventory and warehouse management",
        "Production and manufacturing management",
        "Supply chain management and logistics"
        ]
        },
        {
        title : "Human Resources in Dynamics 365",
        content: [
        "Employee management and HR administration",
        "Talent management and recruitment",
        "Performance and goal management",
        "Compensation and benefits management",
        "Training and development management"
        ]
        },
        {
        title : "Power Platform Integration with Dynamics 365",
        content: [
        "Introduction to the Power Platform",
        "Power Apps development and customization",
        "Power BI reporting and analytics",
        "Power Automate workflow automation",
        "Common Data Service integration"
        ]
        },
        {
        title : "Customization and Configuration in Dynamics 365",
        content: [
        "Customizing entity forms and fields",
        "Creating and modifying views and dashboards",
        "Customizing business processes and workflows",
        "Creating and managing custom entities",
        "Data import and export"
        ]
        },
        {
        title : "Administration and Security in Dynamics 365",
        content: [
        "Managing users and security roles",
        "Configuring system settings and options",
        "Customizing themes and branding",
        "Managing solutions and customizations",
        "System monitoring and performance tuning"
        ]
        },
    ]

    const faqData = [
      {
        question: 'What is Microsoft Dynamics 365?',
        answer:
          'Microsoft Dynamics 365 is a cloud-based business application platform that integrates various business processes, including customer relationship management (CRM), enterprise resource planning (ERP), finance, operations, and more. It empowers organizations to streamline their operations, enhance customer experiences, and drive overall business growth',
      },
      {
        question: 'Are there any hands-on projects included in the Dynamics 365 course?',
        answer:
          'Absolutely! Our Dynamics 365 Training program includes several hands-on projects and simulations that mimic real-world business scenarios. These projects will help you apply your knowledge and gain practical experience',
      },
      {
        question: 'What career opportunities are available after the Dynamics 365 course?',
        answer:
          'After completing our Dynamics 365 course, you\'ll be qualified for roles such as Dynamics 365 Consultant, Dynamics 365 Functional Consultant, Dynamics 365 Developer, and more. Dynamics 365 skills are in high demand across various industries and organizations',
      },
      {
        question: 'Will I learn to work with different Dynamics 365 modules and applications?',
        answer:
          'Yes, our Dynamics 365 course covers various modules and applications within the Dynamics 365 ecosystem, including Sales, Marketing, Customer Service, Finance, Operations, and more. You\'ll gain exposure to different business scenarios and learn to customize and integrate these modules',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"To enroll in our comprehensive Dynamics 365 course and begin your Dynamics 365 Training journey, no prior experience with Microsoft products is required. Our beginner-friendly Dynamics 365 course is designed for learners from diverse backgrounds, including students, professionals seeking to upskill, or anyone interested in mastering this powerful business application platform. Basic computer literacy skills, such as navigating software interfaces and using the internet, are recommended but not mandatory. Throughout the Dynamics 365 course, you'll start from the fundamentals, gaining a solid understanding of the core modules, customization capabilities, and integration with other Microsoft products. With hands-on projects and real-world scenarios, this Dynamics 365 Training equips you with the skills to streamline business processes, enhance customer relationships, and drive operational efficiency using the latest Dynamics 365 features"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Manikandan",
          date:" Agust 09 ,2023",
          review:`learnsoft.org in ${this.props.location} provides an ideal environment for Dynamics 365 training. With state-of-the-art facilities and resources, it ensures a seamless learning experience.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ajith",
          date:" Agust 29 ,2023",
          review:
          " Dynamic365 training and certification at learnsoft.org is a strategic move towards career excellence. With seasoned instructors, hands-on experience, and the prestige of certification, learnsoft.org positions itself as the premier choice for those looking to excel in the realm of Dynamic365."
        },
  ]
     return(
      <>
{/*         
          <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the dynamic landscape of modern business, adaptability and efficiency are key. Microsoft Dynamics 365 emerges as a transformative force, offering a cloud-based platform that seamlessly integrates Customer Relationship Management (CRM) and Enterprise Resource Planning (ERP). Beyond these core functions, it extends its capabilities to encompass a suite of productivity applications and cutting-edge artificial intelligence tools."/>
     */}
          <NewMainsec rating='4.0' students={'900'} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the dynamic landscape of modern business, adaptability and efficiency are key. Microsoft Dynamics 365 emerges as a transformative force, offering a cloud-based platform that seamlessly integrates Customer Relationship Management (CRM) and Enterprise Resource Planning (ERP). Beyond these core functions, it extends its capabilities to encompass a suite of productivity applications and cutting-edge artificial intelligence tools."/>
           
            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		      <Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`At our institute, we offer the best Dynamics 365 ${this.props.location1}, designed to help individuals enhance their skills and gain a comprehensive understanding of Dynamics 365 principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to Dynamics 365 or looking to expand your skillset, our Dynamics 365 ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our courses and start your Dynamics 365 journey.`} 
           title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our Dynamics 365 course covers a wide range of topics, including CRM configuration, customization, and administration, PowerApps, Power BI, and more. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in Dynamics 365. By the end of the course, you will be able to implement Dynamics 365 practices in your own projects."}/>
          </section>
 <Batchtime title={this.props.title}  offer="29,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou="Scrum Master" coupath="scrum-master" cou1='Pega' coupath1='pega' cou2='Kanban' coupath2='kanban' cou3='PowerApps' coupath3='powerapps' cou4='Jira' coupath4='jira-admin' 
          cou5='Endpoint Manager' coupath5='endpoint-manager' cou8='Azure' coupath8='azure' cou7='AWS' coupath7='aws' cou6='Okta' coupath6='okta' cou9='Mulesoft' coupath9='mulesoft'  cou10='SAP' coupath10='sap'/>
     
      </>
    );
  }
}
